import React, { useEffect, useState } from 'react';
import OnboardingLayout from '../registrations/onboarding-layout';
import { store } from '../../../redux/store';
import { Provider } from 'react-redux';
import { ENDPOINTS, API_ENDPOINTS, CONSTS } from '../utils/endpoints';
import { http_get } from '../utils/api_client';
import Loader from '../../organisms/loader/Loader';

const IndexPage = ({token = ""}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [userData, setUserData] = useState(null)

    useEffect(() => {
        if(token){
            localStorage.setItem(CONSTS.AUTH_TOKEN, token);            
        }
        http_get(API_ENDPOINTS.GET_PROFILE)
            .then((response) => {
                setIsLoading(false);
                const data = response?.data;
                if(data){
                    setUserData(data)
                }
            })
            .catch((error) => {
                window.location.href = ENDPOINTS.ROOT;
            });
    }, []);

    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (
                <Provider store={store}>
                    <div className="un-registrations">
                        <OnboardingLayout userProfile={userData?.profile} user={userData?.user} />
                    </div>
                </Provider>
            )}
        </>
    );
};

export default IndexPage;
